import {isFeatureEnabled} from 'feature-flags';
import {Card, Separator} from 'platform/components';
import {Box, HStack, Show} from 'platform/foundation';
import {match, Pattern} from 'ts-pattern';

import {ReactNode} from 'react';

import {featureFlags} from '@dms/feature-flags';
import {DataGridTreeFolderHandle} from '@dms/shared-aftersales';

import {TestIdProps} from 'shared/web';

import {EagGridScreenWrapper} from 'features/eag-grid';

import {ExternalFilterWithFolderTree} from './ExternalFilterWithFolderTree';

export type FullscreenDataGridWrapperProps = {
  externalFilterId?: string;
  hideCardWrapper?: true;
  folderTreeRef?: (node: DataGridTreeFolderHandle) => void;
  children: ReactNode;
} & TestIdProps;

export function FullscreenDataGridWrapper(props: FullscreenDataGridWrapperProps) {
  // When EagGrid is active (EAG_GRID flag ON), the grid wrapper must constrain
  // its width so it doesn't overflow the HStack layout alongside the sidebar.
  // EagGridScreenWrapper measures available width via ResizeObserver and applies
  // max-width — the same JS-based approach used for height in EagGridInner.
  const gridChildren = isFeatureEnabled(featureFlags.EAG_GRID) ? (
    <EagGridScreenWrapper>{props.children}</EagGridScreenWrapper>
  ) : (
    props.children
  );

  const content = match(props.externalFilterId)
    .with(Pattern.nullish, () => (
      <Box height="100%" width="100%">
        {gridChildren}
      </Box>
    ))
    .otherwise(() => (
      <HStack height="100%" data-testid={props['data-testid']}>
        <Show when={props.externalFilterId}>
          <ExternalFilterWithFolderTree
            ref={props.folderTreeRef}
            externalFilterId={props.externalFilterId as string}
            width={100}
            data-testid={`${props['data-testid']}-externalFilterWithFolderTree`}
          />
        </Show>

        <Separator orientation="vertical" />

        <Box height="100%" width="100%">
          {gridChildren}
        </Box>
      </HStack>
    ));

  if (props.hideCardWrapper) {
    return content;
  }

  return <Card isFullHeight>{content}</Card>;
}
